import { render, staticRenderFns } from "./AdmissionExaminationRoomSave.vue?vue&type=template&id=644b9cc2&"
import script from "./AdmissionExaminationRoomSave.vue?vue&type=script&lang=js&"
export * from "./AdmissionExaminationRoomSave.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionExaminationRoomSave.vue?vue&type=style&index=0&id=644b9cc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports